<template>
  <div v-if="cabin" class="flexcabin midblock hoverme"   style="margin-top:10px; margin-bottom:0;">

    <div style="width:20%;overflow-y:hidden">
      <div class="cabin_section">
        <div
            class="cabin_images width100"
            style="position: relative;"
        >
          <div
              v-on:click="toggleFloorPlan()"
              class="view_map_button"
              style="z-index:100;"
          >
            <font-awesome-icon icon="map"/>

          </div>
          <div
              class="view_map_button"
              style="z-index: 100;right: 5px;bottom: initial;top: 5px;left: initial;pointer-events: none; background:none;color:#fff;"
          >
          <font-awesome-icon icon="search-plus"/>

          </div>

          <img
              class="width100 cabin-image resize-image"
              :src="returnCorrectImage()"
          />
        </div>
      </div>
    </div>
    <div style="width:40%;padding-left:10px;display: flex;" class="flexmobile-wrap">
    <div style="width:100%;font-size:16px;padding-top:20px;" v-on:click="doClick(cabin)">
      <b class="cabinname">{{ cabin.naam }} {{ cabin.code }}</b><br>
      <span v-if="cabin.faciliteiten != null && cabin.faciliteiten.oppervlakte" style="font-size:11px;color:#818588">
         <font-awesome-icon icon="map"/> {{ cabin.faciliteiten.oppervlakte }} 	&#13217;
      </span>
      <span v-if="cabin.max_bezetting && cabin.faciliteiten != null && cabin.faciliteiten.oppervlakte"   style="font-size:11px;color:#818588">
         -
      </span>
      <span v-if="cabin.max_bezetting"  style="font-size:11px;color:#818588">
         <font-awesome-icon icon="user"/> Max {{ cabin.max_bezetting }} pers.
      </span>
      <span v-if="cabin.max_bezetting && cabin.faciliteiten != null && cabin.faciliteiten.dek"   style="font-size:11px;color:#818588">
         -
      </span>

      <span v-if=" cabin.faciliteiten != null && cabin.faciliteiten.dek" style="font-size:11px;color:#818588">
            Dek: {{ cabin.faciliteiten.dek}}
     </span>
    </div>



    </div>
    <div style="width:40%;display: flex;" v-on:click="doClick(cabin)">
      <div style="width:50%;display: flex;flex-flow:column;justify-content: center;">
        <span
            v-if="cabin.apiData && cabin.apiData.prijs"
        >
                        <h2 class="darkblue bold" style="font-weight: normal;font-size:16px;text-align: center !important;width:100%;">
                            €
                            {{
                            roundPrice(
                                cabin.apiData.prijs /
                                payload.cabins[0].volwassenen,
                            )
                          }}
                            <small v-if="payload.cabins[0].volwassenen > 1"
                            >p.p.</small
                            >
                        </h2>
                    </span>
      </div>
      <div style="width:50%;display: flex;flex-flow:column;justify-content: center;">
        <div v-if="canSelect(cabin) && cabin.apiData.prijs && (!isSelected || activeStep === 4)" style="width:90%;margin-top:-10px;">
          <button
              v-on:click="doClick(cabin)"
              type="button"
              :id="'testCabinSelect' + index"
              class="btn btn-success btn-addon width100 font14 bold floatleft margintop10"
          >
            Selecteer <font-awesome-icon icon="angle-right" />
          </button>
          <br/>
        </div>
        <div v-else-if="canSelect(cabin) && cabin.apiData.prijs && activeStep === 5" style="text-align: center">
          <b><u>Geselecteerd</u></b>
          <br/>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import {
    faCheck,
    faExclamation,
    faInfo,
    faMap,
    faSearchPlus,
    faMinus,
    faPlus,
    faSpinner,
    faTimes,
} from '@fortawesome/free-solid-svg-icons'

library.add(faCheck)
library.add(faSpinner)
library.add(faMap)
library.add(faSearchPlus)
library.add(faInfo)
library.add(faExclamation)
library.add(faPlus)
library.add(faMinus)
library.add(faTimes)

export default {
    name: 'CabinAvailabilityResult',
    props: {
        cabin: Object,
        index: Number,
        activeStep: Number,
        payload: Object,
        cruise: Object,
        isSelected: Boolean,
        availabilityReceived: Boolean,
        deckNames: Object,
        numberWithCommas: Function,
        roundPrice: Function,
        cabinName: Function,
        ajaxCalls: Number,
        findRateName: Function,
    },
    data: function() {
        return {
            floorPlanVisible: false,
            highlightDekNumber: null,
        }
    },
    computed: {
        rateName: function() {
            return this.findRateName(
                this.cabin.apiData.rateName,
                this.cabin.apiData.rateCode
            ).rateName
        },
        cabinFaciliteitenUSPS: function() {
            if (
                this.cabin !== {} &&
                this.cabin.faciliteiten &&
                this.cabin.faciliteiten.usps
            ) {
                return this.cabin.faciliteiten.usps
            }
            return []
        },
    },
    methods: {
        toggleShow: function(val) {
            if (val.detail === '') return false

            if (val.showDetail === true) {
                val.showDetail = false
            } else {
                val.showDetail = true
            }
            if (val.icon === 'plus') {
                val.icon === 'min'
            }
            if (val.icon === 'min') {
                val.icon === 'plus'
            }
        },
        validateIcon: function(icon) {
            if (icon === '') {
                return 'check'
            }
            return icon
        },
        dekstringToArray: function() {
            if (this.cabin.faciliteiten && this.cabin.faciliteiten.dek) {
                let self = this
                let dekStr = self.cabin.faciliteiten.dek
                return dekStr.split(',')
            }
            return null
        },
        matchingServiceCodes: function() {
            if (
                this.cruise &&
                this.cruise.ratecode_usps &&
                this.cruise.ratecode_usps.services &&
                this.cabin.apiData &&
                this.cabin !== {} &&
                this.cabin.apiData !== false &&
                this.cabin.apiData.autoItems
            ) {
                let self = this
                let retAr = []
                self.cruise.ratecode_usps.services.forEach(function(
                    uspsService
                ) {
                    // for each in json data
                    self.cabin.apiData.autoItems.forEach(function(autoItem) {
                        // for each in cabin api data auto items
                        if (
                            uspsService.serviceCode === autoItem.code ||
                            uspsService.serviceCode === autoItem.description
                        ) {
                            // if match
                            uspsService.uspsItems.forEach(function(uspsItem) {
                                // push to array containing uspsItems
                                if (uspsItem.text) {
                                    retAr.push(uspsItem)
                                }
                            })
                        }
                    })
                })
                return retAr
            }
            return []
        },
        matchingRateCodes: function() {
            if (
                this.cruise &&
                this.cruise.ratecode_usps &&
                this.cruise.ratecode_usps.rates &&
                this.cabin.apiData
            ) {
                let rateCode = this.cabin.apiData.rateCode
                let rateName = this.cabin.apiData.rateName

                let found = this.cruise.ratecode_usps.rates.filter(function(
                    usps
                ) {
                    return (
                        (usps.rateCode === rateCode ||
                            usps.rateCode === rateName) &&
                        usps.text !== ''
                    )
                })
                if (!found[0]) {
                    return []
                }
                return found[0].uspsItems
            }
            return []
        },
        buttonText: function(isSelected) {
            if (isSelected) {
                return 'Ga door'
            }
            return 'Selecteren'
        },
        canSelect: function(cabin) {
            if (cabin.apiData) {
                return true
            }
            return false
        },
        doClick: function(cabin) {
            if (this.canSelect(cabin)) {
                this.$emit('selectCabin-click')
            }
        },
        toggleFloorPlan: function() {
            if (this.floorPlanVisible) {
                this.floorPlanVisible = false
            } else {
                this.floorPlanVisible = true
            }
        },
        returnCorrectImage: function() {
            if (this.floorPlanVisible) {
                return this.cabin.img_plattegrond_url
            }
            return this.cabin.img_url
        },
        returnCorrectAction: function() {
            if (this.floorPlanVisible) {
                return 'Hut'
            } else {
                return 'Plattegrond'
            }
        },
    },
}
</script>

<style lang="scss">
.selectedCabin {
  border-bottom: 0px solid transparent;
  border-radius: 5px 5px 0 0;
  background: #f3f9fd;
}
.selectedCabin ~ .show .midblock {
  box-shadow: unset;
  border-top: none;
  border-radius: 0 5px 5px;
}
.map-icon {
    position: absolute;
    bottom: 5px;
    right: 5px;
    color: #000 !important;
    background-color: #fff;
    padding: 3px 7px;
    border-radius: 3px;
    font-size: 0.7em;
    -webkit-box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.5);
    box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.5);
}

.cabin-banner {
  display:none;
    background: #2178b3;
    color: white;
    padding: 2px 5px;
    position: absolute;
    top: 10px;
    left: 10px;
    border-radius: 5px;
}

.cabin-image {
    border-radius: 5px 0 0 0;
}

.deckNumber {
    cursor: pointer;
}
.cabinname {
  font-size: 16px;
}
@media screen and (max-width: 900px) {
  .flexmobile-wrap {
    flex-flow:column;

    padding-right:10px;
    width:30% !important;
  }
  .flexcabin .cabin_section .cabin_images
  {
    display: block;
    height:100%;
    width: calc(100% - 10px) !important;
    aspect-ratio: 2/1;
    margin-right:5px;
  }
  .flexcabin.midblock > div:first-child {
    width: 50% !important;
    flex-flow:column;
    justify-content: center;
  }
  .flexcabin.midblock > div:nth-child(2) {
    width:50% !important;
    box-sizing: border-box;
    padding:10px;
    display: flex;
    flex-flow:row;
  }
  .flexcabin.midblock > div:nth-child(3) {
    width:100% !important;
  }
  .flexmobile-wrap div:first-child {
    padding-top:0 !important;
    display: initial;
    justify-content:space-between;
    flex-flow:column;
  }
  .flexcabin.midblock > div:nth-child(2) h2 {
    margin-top:5px;
    margin-bottom:10px;
  }

  .flexmobile-wrap div {
    width:100% !important;
    flex-flow:column;
  }

  .cabin-wrapper .cabin-container.cabin-container-vertical .item {
    margin-bottom: 15px !important;

  }
  .flexcabin {
    flex-wrap: wrap;
  }
}
@media screen and (max-width: 380px) {
  .cabinname {
    font-size: 12px;
  }
}
.cabin-wrapper .cabin-container.cabin-container-vertical .item.selectedCabin {
  border: 1px solid #afc9da;
  box-sizing: border-box;
  border-radius:5px;
  padding-right: 0 !important;
  margin-top:10px !important;
  .flexcabin {
    margin-top:0 !important;

  }

  .show .midblock {
    box-sizing:border-box;
  }
}
</style>
